import { z } from 'zod'

export const tenantStatusSchema = z.enum([
  'trialing',
  'active',
  'past_due',
  'suspended',
  'cancelled',
])

export const tenantSchema = z.object({
  id: z.string().ulid(),
  name: z.string().min(1),
  slug: z.string().min(1).regex(/^[a-z0-9-]+$/, 'Slug must be lowercase with hyphens'),
  owner_user_id: z.string().ulid(),
  plan_id: z.string().min(1),
  status: tenantStatusSchema,
  d1_database_id: z.string(),
  r2_bucket_name: z.string(),
  custom_domain: z.string().optional(),
  trial_ends_at: z.string().datetime().optional(),
  subscription_id: z.string().optional(),
  max_users: z.number().int().positive(),
  max_companies: z.number().int().positive(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
})

export const planSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  price_monthly: z.number().nonnegative(),
  price_yearly: z.number().nonnegative(),
  max_users: z.number().int().positive(),
  max_companies: z.number().int().positive(),
  max_storage_gb: z.number().positive(),
  available_modules: z.array(z.string()),
  features: z.record(z.unknown()),
  is_active: z.number().int(),
})

export const tenantModuleSchema = z.object({
  id: z.string().ulid(),
  tenant_id: z.string().ulid(),
  module: z.string(),
  isEnabled: z.number().int(),
  enabled_at: z.string().datetime(),
  created_at: z.string().datetime(),
  created_by: z.string().nullable().optional(),
  updated_at: z.string().datetime(),
  updated_by: z.string().nullable().optional(),
})

export const createTenantInputSchema = z.object({
  name: z.string().min(1, 'กรุณากรอกชื่อร้าน'),
  slug: z.string().min(1).regex(/^[a-z0-9-]+$/, 'ต้องเป็นตัวอักษรภาษาอังกฤษพิมพ์เล็กและขีด'),
  plan_id: z.string().min(1),
})
